import { createSlice } from '@reduxjs/toolkit';

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    term: '',
    filters: {},
    results: [],
    loading: false,
    error: null
  },
  reducers: {
    setSearchTerm: (state, action) => {
      state.term = action.payload;
    },
    setSearchFilters: (state, action) => {
      state.filters = action.payload;
    },
    setSearchResults: (state, action) => {
      state.results = action.payload;
    },
    setSearchLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSearchError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const {
  setSearchTerm,
  setSearchFilters,
  setSearchResults,
  setSearchLoading,
  setSearchError
} = searchSlice.actions;

export default searchSlice.reducer; 